import React, { Fragment, useEffect, useState } from 'react'
import FsLightbox from 'fslightbox-react';

import { Row, Col, Image, Form, Nav, Dropdown, Tab, OverlayTrigger, Popover, Badge, Tooltip } from 'react-bootstrap'
import Card from '../../../components/Card'

import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
// img

import avatars11 from '../../../assets/images/avatars/01.png'
import avatars22 from '../../../assets/images/avatars/avtar_1.png'
import avatars33 from '../../../assets/images/avatars/avtar_2.png'
import avatars44 from '../../../assets/images/avatars/avtar_3.png'
import avatars55 from '../../../assets/images/avatars/avtar_4.png'
import avatars66 from '../../../assets/images/avatars/avtar_5.png'
import avatars2 from '../../../assets/images/avatars/02.png'
import avatars3 from '../../../assets/images/avatars/03.png'
import avatars4 from '../../../assets/images/avatars/04.png'
import avatars5 from '../../../assets/images/avatars/05.png'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


import icon1 from '../../../assets/images/icons/01.png'
import icon2 from '../../../assets/images/icons/02.png'
import icon3 from '../../../assets/images/icons/03.png'
import icon4 from '../../../assets/images/icons/04.png'
import icon8 from '../../../assets/images/icons/08.png'
import icon6 from '../../../assets/images/icons/06.png'
import icon7 from '../../../assets/images/icons/07.png'

import icon5 from '../../../assets/images/icons/05.png'
import shap2 from '../../../assets/images/shapes/02.png'
import shap4 from '../../../assets/images/shapes/04.png'
import shap6 from '../../../assets/images/shapes/06.png'
import pages2 from '../../../assets/images/pages/02-page.png'

import ShareOffcanvas from '../../../components/partials/components/shareoffcanvas'
import { userSignal } from '../../../signal/userSignal';
import { allUsersSignal } from '../../../signal/allUsersSignal';
import * as moment from 'moment';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { DEV_SERVER } from '../../../constants/urls';
import axios from 'axios';
import TripListOfUser from '../trips/TripListOfUser';
import PerformanceChart from '../trips/performance-chart';
import Attendence from '../attendence/Attendence';
import ExpenseListOfUser from '../expenses/ExpenseListOfUser';
import LeavesListOfUser from '../leaves/LeaveListOfUser';
import Circularprogressbar from '../../../components/circularprogressbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from "swiper";
import { userExcelGenerator } from '../../../utilities/excelGenerator';
import ExcelExport from "../../../assets/images/icons/excel-export.svg"
import { organisationSignal } from '../../../signal/organisationSignal';
import OrderListOfUser from '../order/OrderListOfUser';

// install Swiper modules
SwiperCore.use([Navigation]);

const EmployeeProfile = (props) => {

    let today = new Date()
    let yesterday = new Date(today - 24 * 60 * 60 * 1000).getTime();
    // get date start Time of month's first day
    let monthStartDay = new Date(new Date(yesterday).getFullYear(), new Date(yesterday).getMonth(), 1).getTime();
    const [searchParams, setSearchParams] = useSearchParams();
    const [toggler, setToggler] = useState();
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(monthStartDay).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(yesterday).format("YYYY-MM-DD"));
    const [trips, setTrips] = useState([]);
    const [attendences, setAttendences] = useState([]);
    const [expenses, setExpenses] = useState([]);
    const [orders, setOrders] = useState([]);
    const [periodicExpenses, setPeriodicExpenses] = useState([]);
    const [leaves, setLeaves] = useState([]);
    const [user, setUser] = useState({});
    
    const [summary, setSummary] = useState({
        totalDistance: 0,
        totalNewCustomers: 0,
        totalExpense: 0,
    });
    const [totalLeaves, setTotalLeaves] = useState(0);
    const [totalPeriodicExpense, setTotalPeriodicExpense] = useState(0);

    const url = useLocation();
    const navigate = useNavigate();
    const id = url.pathname.split("/")[3];
    
    // Fetch sorted users list for prev/next navigation
    const usersList = Object.values(allUsersSignal?.value || {}).filter(u => !u.isTallySyncMaster);
    const stateName = window.localStorage.getItem("state");
    const sortedUsers = stateName 
        ? usersList.filter(u => u.state === stateName)
        : usersList;
    sortedUsers.sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));

    const currentIndex = sortedUsers.findIndex(u => u.id === id || u._id === id);
    const prevUser = currentIndex > 0 ? sortedUsers[currentIndex - 1] : null;
    const nextUser = (currentIndex !== -1 && currentIndex < sortedUsers.length - 1) 
        ? sortedUsers[currentIndex + 1] 
        : null;

    const handlePrevUser = () => {
        if (prevUser) {
            navigate(`/dashboard/users/${prevUser.id || prevUser._id}?fromDate=${fromDate}&toDate=${toDate}`);
        }
    };

    const handleNextUser = () => {
        if (nextUser) {
            navigate(`/dashboard/users/${nextUser.id || nextUser._id}?fromDate=${fromDate}&toDate=${toDate}`);
        }
    };

    const getVariableColor = () => {
        let prefix =
            getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
        if (prefix) {
            prefix = prefix.trim();
        }
        const color1 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary`
        );
        const color2 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}info`
        );
        const color3 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}primary-tint-20`
        );
        const color4 = getComputedStyle(document.body).getPropertyValue(
            `--${prefix}warning`
        );
        return {
            primary: color1.trim(),
            info: color2.trim(),
            warning: color4.trim(),
            primary_light: color3.trim(),
        };
    };
    const variableColors = getVariableColor();

    const colors = [variableColors.primary, variableColors.info];
    useEffect(() => {
        return () => colors;
    });

    const userDetails = useQuery("userDetails", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/employee/${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setUser(data.data);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            console.log(error);
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");

            }
            navigate("/dashboard/users");
        }
    })

    const employeePerformance = useQuery("employeePerformance", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/employee/performance/${id}?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setTrips(data?.data?.trips);
                let totalDistance = 0;
                let totalNewCustomers = 0;
                let totalExpense = 0;
                for (let i = 0; i < data?.data?.trips?.length; i++) {
                    totalDistance += data.data.trips[i].totalDistance;
                    totalNewCustomers += data.data.trips[i].totalNewCustomers;
                    totalExpense += data.data.trips[i].totalExpense;
                }
                setSummary({
                    totalDistance,
                    totalNewCustomers,
                    totalExpense
                })

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const employeeAttendence = useQuery("employeeAttendence", async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/attendence/${id}?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setAttendences(data.data);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const expensesMutation = useQuery("expenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&userId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setExpenses(data.data);
                // userExcelGenerator({ expenses: data.data, leaves, trips })
            } else {
                toast.error(data.message);
            }
        },
    })

    const orderMutation = useQuery("orders", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&userId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setOrders(data.data);
            } else {
                toast.error(data.message);
            }
        },
    })


    const periodicExpensesMutation = useQuery("periodicExpenses", async () => {
        let resp = await axios.get(`${DEV_SERVER}/expense/v2/periodicExpenses?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&userId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setPeriodicExpenses(data.data);
                let periodicExpense = 0;
                for (let i = 0; i < data?.data?.length; i++) {
                    periodicExpense += data.data[i].amount;
                }
                setTotalPeriodicExpense(periodicExpense);
            } else {
                toast.error(data.message);
            }
        },
    })

    const leavesMutation = useQuery("leaves", async () => {
        let resp = await axios.get(`${DEV_SERVER}/leave/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&userId=${id}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setLeaves(data?.data);
                let leaves = 0;
                for (let i = 0; i < data?.data?.length; i++) {
                    // days from startTime and endTime, startTime and endTime are in milliseconds
                    if (data.data[i].status === "approved") {
                        let days = Math.ceil((data?.data[i]?.endTime - data?.data[i]?.startTime) / (1000 * 60 * 60 * 24));
                        leaves += days;
                    }
                }
                setTotalLeaves(leaves);
            } else {
                toast.error(data.message);
            }
        },
    })

    const expenseRefetch = () => {
        expensesMutation.refetch({ cancelRefetch: true });
    }

    const leaveRefetch = () => {
        leavesMutation.refetch({ cancelRefetch: true });
    }

    useEffect(() => {
        userDetails.refetch({ cancelRefetch: true });
        employeePerformance.refetch({ cancelRefetch: true });
        employeeAttendence.refetch({ cancelRefetch: true });
        expensesMutation.refetch({ cancelRefetch: true });
        leavesMutation.refetch({ cancelRefetch: true });
        periodicExpensesMutation.refetch({ cancelRefetch: true });
        if(organisationSignal?.value?.isOrderModuleActivated){
            orderMutation.refetch({ cancelRefetch: true });
        }
    }, [id])


    const handleDateChange = (e) => {

        let tempSearch = new URLSearchParams({
            fromDate: fromDate,
            toDate: toDate
        })

        setSearchParams(tempSearch);

        userDetails.refetch({ cancelRefetch: true });
        employeePerformance.refetch({ cancelRefetch: true });
        employeeAttendence.refetch({ cancelRefetch: true });
        expensesMutation.refetch({ cancelRefetch: true });
        leavesMutation.refetch({ cancelRefetch: true });
        periodicExpensesMutation.refetch({ cancelRefetch: true });
        if(organisationSignal?.value?.isOrderModuleActivated){
            orderMutation.refetch({ cancelRefetch: true });
        }
    }

    return (
        <Fragment>
            <FsLightbox
                toggler={toggler}
                sources={[icon4, shap2, icon8, shap4, icon2, shap6, icon5, shap4, icon1]}
            />
            {(userDetails.isLoading) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> :
                <Tab.Container defaultActiveKey="first">
                    <Row>
                        <Col lg="12" style={{ marginTop: "3rem" }}>
                            <Card>
                                <Card.Body>
                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                        <div className="d-flex flex-wrap align-items-center">
                                            <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                {user?.profileURL !== "" ? <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="rounded-circle img-fluid avatar-100" src={user?.profileURL} alt="profile-img" /></Zoom> : <>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-default-img  img-fluid rounded-pill avatar-100" src={avatars11} alt="profile-pic" /></Zoom>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-purple-img img-fluid rounded-pill avatar-100" src={avatars22} alt="profile-pic" /></Zoom>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-blue-img img-fluid rounded-pill avatar-100" src={avatars33} alt="profile-pic" /></Zoom>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-green-img img-fluid rounded-pill avatar-100" src={avatars55} alt="profile-pic" /></Zoom>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-yellow-img img-fluid rounded-pill avatar-100" src={avatars66} alt="profile-pic" /></Zoom>
                                                    <Zoom><Image onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none" }} className="theme-color-pink-img img-fluid rounded-pill avatar-100" src={avatars44} alt="profile-pic" /></Zoom>
                                                </>}
                                            </div>
                                            <div className='d-flex flex-column'>
                                                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                    <h4 className="me-2 h4">{user?.name} <Badge bg={user?.userType === "employee" ? "info" : (user?.isAdmin ? "primary" : "success")}>{user?.userType === "employee" ? user?.userType : (user?.isAdmin ? "Super Admin" : "Manager")}</Badge></h4>
                                                </div>
                                                <span>{user?.designation}</span>
                                            </div>

                                        </div>
                                        <div className='d-flex align-items-center' style={{ columnGap: '1.5rem' }}>
                                            <div className='d-flex flex-column align-items-end'>
                                                <span>Phone Number - {user?.phoneNumber}</span>
                                                <span>Password - {user?.password} <OverlayTrigger trigger="click" placement="top" rootClose overlay={<Popover id="popover-basic"><Popover.Header as="h3">Copied</Popover.Header></Popover>}>
                                                    <i onClick={() => navigator.clipboard.writeText(user?.password || "")} style={{ cursor: "pointer" }} class="fas fa-copy"></i>
                                                </OverlayTrigger>
                                                </span>
                                            </div>
                                            <div className="btn-group" role="group">
                                                <button 
                                                    className="btn btn-outline-primary btn-sm d-flex align-items-center" 
                                                    onClick={handlePrevUser} 
                                                    disabled={!prevUser}
                                                    title={prevUser ? `Go to ${prevUser.name}` : "No previous user"}
                                                    style={{ height: 'fit-content' }}
                                                >
                                                    <i className="fas fa-chevron-left me-1"></i> Prev
                                                </button>
                                                <button 
                                                    className="btn btn-outline-primary btn-sm d-flex align-items-center" 
                                                    onClick={handleNextUser} 
                                                    disabled={!nextUser}
                                                    title={nextUser ? `Go to ${nextUser.name}` : "No next user"}
                                                    style={{ height: 'fit-content' }}
                                                >
                                                    Next <i className="fas fa-chevron-right ms-1"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg="12">
                            <Card>
                                <Card.Body>
                                    <Row className="row-cols-1">
                                        <div className="d-slider1 ">
                                            <Swiper
                                                className="p-0 m-0 mb-2 list-inline "
                                                slidesPerView={5}
                                                spaceBetween={32}
                                                navigation={{
                                                    nextEl: ".swiper-button-next",
                                                    prevEl: ".swiper-button-prev",
                                                }}
                                                breakpoints={{
                                                    320: { slidesPerView: 1 },
                                                    550: { slidesPerView: 2 },
                                                    991: { slidesPerView: 3 },
                                                    1400: { slidesPerView: 3 },
                                                    1500: { slidesPerView: 4 },
                                                    1920: { slidesPerView: 4 },
                                                    2040: { slidesPerView: 7 },
                                                    2440: { slidesPerView: 8 }
                                                }}

                                            >
                                                <SwiperSlide className="card card-slide" >
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.primary}
                                                                width="60px"
                                                                height="60px"
                                                                Linecap="rounded"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                style={{ width: 60, height: 60 }}
                                                                value={90}
                                                                id="circle-progress-01"
                                                            >
                                                                {summary?.totalDistance === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Distance</p>
                                                                <h4 className="counter">
                                                                    {parseFloat(summary?.totalDistance / 1000).toFixed(2)} km
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.info}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={60}
                                                                id="circle-progress-02"
                                                            >
                                                                {summary?.totalNewCustomers === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Customers</p>
                                                                <h4 className="counter">
                                                                    {summary?.totalNewCustomers}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.primary}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={70}
                                                                id="circle-progress-03"
                                                            >
                                                                <svg className="" width="24" viewBox="0 0 24 24">
                                                                    <path
                                                                        fill="currentColor"
                                                                        d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                    />
                                                                </svg>
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Expense</p>
                                                                <h4 className="counter">
                                                                    ₹ {(parseFloat(summary?.totalExpense + totalPeriodicExpense) > 1000 ? parseFloat(parseFloat(summary?.totalExpense + totalPeriodicExpense) / 1000).toFixed(2) + "K" : parseFloat(parseFloat(summary?.totalExpense + totalPeriodicExpense)).toFixed(2))}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                                <SwiperSlide className=" card card-slide">
                                                    <div className="card-body">
                                                        <div className="progress-widget">
                                                            <Circularprogressbar
                                                                stroke={variableColors.info}
                                                                width="60px"
                                                                height="60px"
                                                                trailstroke="#ddd"
                                                                strokewidth="4px"
                                                                Linecap="rounded"
                                                                style={{ width: 60, height: 60 }}
                                                                value={60}
                                                                id="circle-progress-04"
                                                            >
                                                                {totalLeaves === 0 ?
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M19,6.41L17.59,5L7,15.59V9H5V19H15V17H8.41L19,6.41Z"
                                                                        />
                                                                    </svg> :
                                                                    <svg
                                                                        className=""
                                                                        width="24"
                                                                        height="24px"
                                                                        viewBox="0 0 24 24"
                                                                    >
                                                                        <path
                                                                            fill="currentColor"
                                                                            d="M5,17.59L15.59,7H9V5H19V15H17V8.41L6.41,19L5,17.59Z"
                                                                        />
                                                                    </svg>}
                                                            </Circularprogressbar>
                                                            <div className="progress-detail">
                                                                <p className="mb-2">Total Leaves</p>
                                                                <h4 className="counter">
                                                                    {totalLeaves}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>

                                                <div className="swiper-button swiper-button-next"></div>
                                                <div className="swiper-button swiper-button-prev"></div>
                                            </Swiper>
                                        </div>
                                    </Row>
                                    <div style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem" }}>
                                        <div>
                                            <label htmlFor="fromDate">From Date</label>
                                            <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        </div>
                                        <div>
                                            <label htmlFor="toDate">To Date</label>
                                            <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" value={toDate} max={moment(yesterday).format("YYYY-MM-DD")} onChange={(e) => setToDate(e.target.value)} />
                                        </div>
                                        <button className='btn btn-primary align-self-end' onClick={handleDateChange}>Submit</button>
                                        <div style={{alignSelf: "flex-end", flexGrow: 1}}  className="d-flex align-items-end justify-content-end">
                                        <button className="btn btn-success"
                                        disabled={(expensesMutation.isLoading || leavesMutation.isLoading || employeeAttendence.isFetching || employeeAttendence.isLoading || employeePerformance.isFetching || employeePerformance.isLoading || periodicExpenses.isLoading || periodicExpenses.isFetching)}
                                        onClick={() => userExcelGenerator(expenses, leaves, trips, attendences, periodicExpenses, `${user?.name}-${fromDate}-${toDate}`, fromDate, toDate)}
                                        >
                                            <svg id="SvgjsSvg1001" width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 18765 21993" width="20" height="20"><path fill-rule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white" class="color000 svgShape"></path></svg></g></svg> Export
                                        </button>
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <Nav as="ul" className="d-flex nav-pills mb-0 text-center profile-tab" data-toggle="slider-tab" id="profile-pills-tab" role="tablist">
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="first">Trips</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="second">Performance</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item as="li">
                                                <Nav.Link eventKey="third">Orders</Nav.Link>
                                            </Nav.Item> */}
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="fourth">Expenses</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="fifth">Leaves</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item as="li">
                                                <Nav.Link eventKey="sixth">Attendence</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item as="li">
                                            <Nav.Link eventKey="fourth">Profile</Nav.Link>
                                        </Nav.Item> */}
                                        </Nav>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Tab.Content className="profile-content">
                                <Tab.Pane eventKey="first" id="profile-feed">
                                    {(employeePerformance.isLoading || employeePerformance?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> : <TripListOfUser trips={trips} />}
                                </Tab.Pane>
                                <Tab.Pane eventKey="second" id="profile-activity">
                                    {(employeePerformance.isLoading || employeePerformance?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div> : <PerformanceChart trips={trips} />}
                                </Tab.Pane >
                                {organisationSignal?.value?.isOrderModuleActivated && <Tab.Pane eventKey="third" id="profile-activity">
                                    {(orderMutation?.isLoading || orderMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <OrderListOfUser orders={orders} />}
                                </Tab.Pane >}
                                <Tab.Pane eventKey="fourth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <ExpenseListOfUser expenses={expenses} expenseRefetch={expenseRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="fifth" id="profile-activity">
                                    {(expensesMutation?.isLoading || expensesMutation?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden testclass">Loading...</span>
                                        </div>
                                    </div> : <LeavesListOfUser leaves={leaves} leaveRefetch={leaveRefetch} />}
                                </Tab.Pane >
                                <Tab.Pane eventKey="sixth" id="profile-friends">
                                    {(employeeAttendence.isLoading || employeeAttendence?.isFetching) ? <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
                                        <div className="spinner-border text-primary m-2" role="status">
                                            <span className="visually-hidden tets2">Loading...</span>
                                        </div>
                                    </div> : <Attendence attendences={attendences} fromDate={fromDate} toDate={toDate} />}
                                </Tab.Pane >
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }
        </Fragment>
    )

}

export default EmployeeProfile;